import * as React from 'react';
import Select from 'react-select';
import {
  findCondition,
  startDeclaration,
  clearConditionSearchFlags,
} from '../../../../../../services/verisk/reducer';
import { Button } from 'react-bootstrap';
import { AlertConditionSearch } from './Components';
import { debounce } from 'lodash';

export default class ConditionSearch extends React.Component<any, any> {
  public state = {
    condition: null,
  };

  constructor(props) {
    super(props);

    this.search = debounce(this.search.bind(this), 300);
  }

  private search(query) {
    const {dispatch} = this.props;

    if (!query || query.length < 2) {
      dispatch(clearConditionSearchFlags());
      return;
    }

    dispatch(clearConditionSearchFlags());
    dispatch(findCondition(query));
  }

  public componentDidUpdate(prevProps) {
    if (prevProps.conditionProps !== this.props.conditionProps) {
      this.props.conditionChange(this.state.condition);
    }
  }

  private setCondition = (condition) => {
    const {dispatch} = this.props;

    dispatch(clearConditionSearchFlags());

    this.setState(
      {
        condition,
      },
      () => this.props.conditionChange(condition),
    );
  };

  private handleSubmit = () => {
    const { dispatch, setHasScreenedCondition } = this.props;
    const { condition } = this.state;

    dispatch(clearConditionSearchFlags());

    setHasScreenedCondition(true);
    dispatch(startDeclaration(condition));
  };

  private handleSuggestionClick = (suggestion) => () => {
    const { dispatch } = this.props;

    dispatch(clearConditionSearchFlags());

    this.setCondition(suggestion);
  };

  private renderSuggestionButtons = () => {
    const { screening } = this.props;

    if (!screening?.conditions?.length) return null;

    return (
      <>
        {screening.conditions.map((suggestion, idx) => (
          <Button
            style={{paddingTop: 0, paddingBottom: 0, fontSize: 16}}
            key={idx}
            bsStyle="link"
            onClick={this.handleSuggestionClick(suggestion)}
          >
            {suggestion.label || suggestion.name || suggestion}
          </Button>
        ))}
      </>
    );
  };

  public render() {
    const { index, screening, isControlGroup } = this.props;
    const { condition } = this.state;

    return (
      <div className="search-conditions form-horizontal">
        <div className="form-group">

          {screening?.hasSurgicalProcedure && (
            <AlertConditionSearch
              text="You have searched for a procedure or a surgery, please enter the name for the medical condition instead."
            />
          )}

          {screening?.hasMisspelledConditions && (
            <div>
              <AlertConditionSearch
                text={
                  <>
                    No medical condition was found matching your search. However, did you mean:
                    {this.renderSuggestionButtons()}
                  </>
                }
              />
            </div>
          )}

          {!isControlGroup && (
            <label className="control-label col-xs-3 full-width-xs">
              Search conditions
            </label>
          )}

          {isControlGroup && screening.declaredConditions?.data && (
            <label className="control-label col-xs-12 full-width-xs add-another">
              Need to add another condition?
            </label>
          )}

          <div className={(condition ? 'col-xs-6' : 'col-xs-9') + ' full-width-xs'}>
            <Select
              name={'conditions-search-' + index}
              cache="false"
              value={condition}
              isLoading={screening.isSearching}
              options={screening?.hasSurgicalProcedure ? [] : screening.conditions}
              placeholder={isControlGroup ? 'Start typing condition...' : 'Type Condition'}
              onInputChange={this.search}
              onChange={this.setCondition}
            />
          </div>
          {condition && (
            <div>
              <div className="col-xs-3 full-width-xs">
                {/*<br className="visible-xs visible-sm"/>*/}
                <Button
                  className="screen-button"
                  bsStyle="primary"
                  disabled={screening.isSubmitting || screening.isSearching || !condition}
                  onClick={this.handleSubmit}
                  block={false}
                > {isControlGroup ? 'Screen Condition' : 'Screen'}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
